/**
 * BroadcastChannel name used to communicate between the OAuth popup
 * and the parent window. More reliable than window.opener.postMessage
 * which can be nullified by cross-origin navigation during OAuth flow.
 */
export const OAUTH_CHANNEL_NAME = 'saaga-oauth-callback'
